export default __webpack_public_path__ + "static/media/enter.ccc81243.svg";